export class ButtonAcces {
    btnNuevo: boolean;
    btnEditar: boolean;
    btnEliminar: boolean;
    btnGrabar: boolean;
    btnCerrar: boolean;
    btnPDF: boolean;
    btnEXCEL: Boolean;
    btnDownload: boolean;
    btnVisualizar: boolean;
    btnAdicionarEliminar: boolean;

    btnMenuPadre: boolean;
    btnMenuHijo: boolean;
    btnBuscar: boolean;
    constructor() {
        this.btnNuevo = true;
        this.btnEditar = true;
        this.btnEliminar = true;
        this.btnGrabar = true;
        this.btnCerrar = true;
        this.btnPDF = true;
        this.btnEXCEL = true;
        this.btnDownload = true;
        this.btnVisualizar = true;
        this.btnAdicionarEliminar = true;
        this.btnMenuPadre = true;
        this.btnMenuHijo = true;
        this.btnBuscar = true;
    }
}